import React from 'react'
import {
  IconFolderFilled,
  IconDatabase,
} from '@tabler/icons-react'
import { Link } from 'react-router-dom'
import ReactApexChart from 'react-apexcharts';
import Breadcrumb from '../../components/common/Breadcrumb';

export default function FileDashboard() {

  const chartData = {
    series: [{
      name: 'Documents',
      data: [0, 22, 10, 27, 17, 39, 20],
    },
    {
      name: 'Media',
      data: [0, 12, 1, 12, 9, 51, 9],
    },
    {
      name: 'Images',
      data: [7, 5, 23, 2, 26, 9, 21],
    }],
    options: {
      colors: ['var(--chart-color1)', 'var(--chart-color2)', 'var(--chart-color3)'],
      fill: {
        gradient: {
          inverseColors: true,
          opacityTo: 0.2,
          stops: [0, 0],
        }
      },
      stroke: {
        width: 1,
        curve: 'smooth',
      },
      dataLabels: {
        enabled: false
      },
      markers: {
        size: 1,
        strokeColors: ['var(--chart-color1)', 'var(--chart-color2)', 'var(--chart-color3)'],
        hover: {
          size: 1,
        }
      },
      chart: {
        toolbar: {
          show: false,
        },
      },
      grid: {
        borderColor: 'var(--border)',
      },
      xaxis: {
        categories: ["2011", "2012", "2013", "2014", "2015", "2016", "2017"],
        labels: {
          style: {
            fontFamily: 'var(--font-family)',
          },
        },
        tooltip: {
          enabled: false,
        },
      },
      yaxis: {
        min: 0,
        max: 60,
        tickAmount: 4,
        labels: {
          style: {
            fontFamily: 'var(--font-family)',
          },
        }
      },
      responsive: [{
        breakpoint: 767,
        options: {
          chart: {
            height: 'auto'
          }
        },
      }]
    },
  };

  return (
    <>
      <Breadcrumb title="Dashboard" path="File Manager / Dashboard" />
      <div className='grid lg:grid-cols-4 md:grid-cols-2 lg:gap-30 gap-15 mb-30'>
        <Link to="#" className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex items-center gap-10 text-text-primary transition-all hover:text-primary'>
          <IconFolderFilled className='w-[18px] h-[18px]' />
          <p className='text-[16px]/[20px]'>
            Lucid Project
          </p>
        </Link>
        <Link to="#" className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex items-center gap-10 text-text-primary transition-all hover:text-primary'>
          <IconFolderFilled className='w-[18px] h-[18px]' />
          <p className='text-[16px]/[20px]'>
            Themeforest
          </p>
        </Link>
        <Link to="#" className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex items-center gap-10 text-text-primary transition-all hover:text-primary'>
          <IconFolderFilled className='w-[18px] h-[18px]' />
          <p className='text-[16px]/[20px]'>
            New Website
          </p>
        </Link>
        <Link to="#" className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex items-center gap-10 text-text-primary transition-all hover:text-primary'>
          <IconFolderFilled className='w-[18px] h-[18px]' />
          <p className='text-[16px]/[20px]'>
            My Folder
          </p>
        </Link>
      </div>
      <div className='grid grid-cols-12 lg:gap-30 gap-15'>
        <div className='md:col-span-3 col-span-12'>
          <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 lg:mb-30 mb-15'>
            <div className='flex items-center justify-between gap-10 mb-2 text-text-primary'>
              <p className='text-[24px]/[28.8px] font-medium'>
                1TB
              </p>
              <IconDatabase />
            </div>
            <p className='flex items-center justify-between gap-10'>
              Storage
              <small className="text-text-secondary">
                of 1Tb
              </small>
            </p>
            <div className='progress-striped h-20 bg-bg-light rounded-sm overflow-hidden'>
              <div className="progress-bar w-[43%] h-full bg-warning text-[12px]/[20px] text-black font-medium px-5 text-center">43%</div>
            </div>
          </div>
          <div className='bg-bg-dark shadow-light rounded-lg overflow-hidden mb-10'>
            <div className='md:p-20 p-15'>
              <p className='text-[16px]/[19.2px] font-medium mb-2'>
                2GB
              </p>
              <p className='flex items-center justify-between gap-10'>
                Documents
                <small className="text-text-secondary">
                  of 1Tb
                </small>
              </p>
            </div>
            <div className='h-[5px] rounded-[2px] bg-border overflow-hidden'>
              <div className='w-[18%] bg-chart-color1 h-full'></div>
            </div>
          </div>
          <div className='bg-bg-dark shadow-light rounded-lg overflow-hidden mb-10'>
            <div className='md:p-20 p-15'>
              <p className='text-[16px]/[19.2px] font-medium mb-2'>
                10GB
              </p>
              <p className='flex items-center justify-between gap-10'>
                Media
                <small className="text-text-secondary">
                  of 1Tb
                </small>
              </p>
            </div>
            <div className='h-[5px] rounded-[2px] bg-border overflow-hidden'>
              <div className='w-[34%] bg-chart-color2 h-full'></div>
            </div>
          </div>
          <div className='bg-bg-dark shadow-light rounded-lg overflow-hidden'>
            <div className='md:p-20 p-15'>
              <p className='text-[16px]/[19.2px] font-medium mb-2'>
                20GB
              </p>
              <p className='flex items-center justify-between gap-10'>
                Images
                <small className="text-text-secondary">
                  of 1Tb
                </small>
              </p>
            </div>
            <div className='h-[5px] rounded-[2px] bg-border overflow-hidden'>
              <div className='w-[67%] bg-chart-color3 h-full'></div>
            </div>
          </div>
        </div>
        <div className='md:col-span-9 col-span-12'>
          <div className='bg-bg-dark shadow-light rounded-lg'>
            <div className='md:p-20 p-15'>
              <p className='text-[16px]/[19.2px] font-medium'>
                File Reports
              </p>
            </div>
            <ReactApexChart options={chartData.options} series={chartData.series} type="area" height={350} />
          </div>
        </div>
      </div>
    </>
  )
}
